export default __webpack_public_path__ + "static/bendito-logo-horizontal-3092dc05709d86169eb91bc769d590a7.svg";